
import { axios, BaseApiUrl ,BaseRouterUrl} from '../axios_config';


export function GetShippingPlanStatusList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetShippingPlanStatusList`, params);
}


export function GetPlanRelationStatusList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetPlanRelationStatusList`, params);
}


export function GetStockingTaskAttachList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetStockingTaskAttachList`, params);
}


export function GetTransportTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetTransportTypeList`, params);
}

export function getCustomerList(params) {
    return axios.post(`${BaseApiUrl}/ProductSKU/GetCustomerList`, params);
 }

 export function GetContainerTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetContainerTypeList`, params);
}

export const GetCurrencyServiceModelList = (params) => {
	return axios.post(`${BaseApiUrl}/Util/GetCurrencyServiceModelList`, params);
};
